var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('header-row',{attrs:{"page":_vm.page}}),_vm._v(" "),_vm._l((_vm.page.template.blocks),function(item,index){return _c('two-column-row',{key:item.title,attrs:{"item":item,"index":index}})}),_vm._v(" "),_c('configuration-row',{attrs:{"page":_vm.page}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }